import { curriedGet, curriedPost } from "../../Editor/services/abort-controller";
import { axiosInstance as axios } from "../../Editor/services/axios-provider";
import { HttpHeaders } from "../../../utils/http-utils";

export interface BillingStatus {
  exists: boolean;
  active: boolean;
  planId: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
}

export class SubscriptionService {
  private static readonly statusUrl = "/api/subscription/billing/status";
  private static readonly sessionUrl = "/api/subscription/billing/create-session";
  private static readonly checkoutUrl = "/api/subscription/checkout/initiate";

  private static config: {
    baseURL: string;
    timeout: number;
    headers: HttpHeaders;
  };

  constructor(baseURL: string) {
    SubscriptionService.config = {
      baseURL,
      timeout: 3000,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
  }

  public static async fetchBillingStatus(): Promise<BillingStatus> {
    const res = await curriedGet(SubscriptionService.statusUrl, SubscriptionService.config);
    return res.data;
  }

  public static async createBillingSession(): Promise<{ url: string }> {
    const res = await curriedPost(SubscriptionService.sessionUrl, SubscriptionService.config);
    return res.data;
  }

  public static async initiateCheckout(clientUrl: string): Promise<string> {
    const response = await axios.post(
      SubscriptionService.checkoutUrl,
      { clientUrl },
      { baseURL: SubscriptionService.config.baseURL }
    );
    return new URL(response.data.checkoutUrl, SubscriptionService.config.baseURL).toString();
  }
}
